import classes from './RecordInteraction.module.css';
import RealPlayHeader from 'features/realplays/Components/RealPlayView/RealPlayHeader/RealPlayHeader';
import RealPlayRecorder from 'features/realplays/Components/RealPlayView/RealPlayRecorder/RealPlayRecorder';
import RealPlayInfo from 'features/realplays/Components/RealPlayView/RealPlayInfo/RealPlayInfo';
import RealPlayClientInfo from 'features/realplays/Components/RealPlayView/RealPlayClientInfo/RealPlayClientInfo';
import SubmitRealPlay from './SubmitRoleplay';
const RecordInteraction = () => {
  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <RealPlayHeader isPublic />
        <RealPlayRecorder isPublic />
      </div>
      <div className={classes.right}>
        <RealPlayInfo isPublic />
        <RealPlayClientInfo />
        <SubmitRealPlay />
      </div>
    </div>
  );
};

export default RecordInteraction;
